/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * htoken API
 * OpenAPI spec version: v1
 */
export const KycDtoStatus = {
    NOT_STARTED: 'NOT_STARTED',
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
};
//# sourceMappingURL=kycDtoStatus.js.map